// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutPage_aboutPageContainer__vn\\+Jj {
    background-color: #495E57;
    justify-content: center;
}

.aboutPage_aboutPageContainer__vn\\+Jj h2, .aboutPage_aboutPageContainer__vn\\+Jj p {
    color: #FFF;
}

.aboutPage_aboutPageContainer__vn\\+Jj > .aboutPage_aboutSection__0lJDq .aboutPage_aboutContent__zKkMz {
    display: flex;
    flex-direction: column;
    gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/AboutPage/aboutPage.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".aboutPageContainer {\n    background-color: #495E57;\n    justify-content: center;\n}\n\n.aboutPageContainer h2, .aboutPageContainer p {\n    color: #FFF;\n}\n\n.aboutPageContainer > .aboutSection .aboutContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboutPageContainer": `aboutPage_aboutPageContainer__vn+Jj`,
	"aboutSection": `aboutPage_aboutSection__0lJDq`,
	"aboutContent": `aboutPage_aboutContent__zKkMz`
};
export default ___CSS_LOADER_EXPORT___;
